<template>
  <v-container fluid class="grey lighten-4">
    <v-card>
      <v-expansion-panels v-model="panel">
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div class="d-flex align-center">
              <v-icon left> mdi-filter-variant </v-icon>
              Filtros
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-form :disabled="buscando" @submit.prevent="buscarItensVo">
              <v-row>
                <v-col cols="4" sm="4">
                  <v-text-field v-model="filtro.descricao" label="Descrição" :loading="buscando" />
                </v-col>

                <v-col cols="4" sm="4">
                  <v-text-field
                    v-model="filtro.codigoBarra"
                    label="Código de Barra"
                    :loading="buscando"
                    type="number"
                  />
                </v-col>

                <v-col cols="4" sm="4">
                  <v-text-field
                    v-model="filtro.codigoNcm"
                    label="NCM "
                    :loading="buscando"
                    type="number"
                  />
                </v-col>

                <v-col cols="4" sm="4">
                  <v-text-field
                    v-model="filtro.codigoNesh"
                    label="NESHs da NCM "
                    :loading="buscando"
                  />
                </v-col>

                <v-col cols="4" sm="4">
                  <v-autocomplete
                    v-model="itemUf"
                    :items="itensUF"
                    label="UF ICMS"
                    :loading="buscando"
                  />
                </v-col>

                <v-col cols="4" sm="4">
                  <v-text-field v-model="filtro.codigoVo" label="Código VO" :loading="buscando" />
                </v-col>

                <v-col cols="4" sm="4">
                  <v-autocomplete
                    v-model="filtro.outros"
                    :items="itensOutrosFiltros"
                    label="Outros filtros"
                    :loading="buscando"
                    clearable
                  />
                </v-col>

                <v-col cols="auto" class="d-flex align-center">
                  <v-btn class="ml-4" color="primary" outlined type="submit" :loading="buscando">
                    <v-icon left> mdi-magnify </v-icon>
                    Aplicar
                  </v-btn>
                  <v-btn
                    class="ml-4"
                    color="normal"
                    outlined
                    type="submit"
                    :loading="buscando"
                    @click.stop.prevent="limparSelecaoDeFiltros"
                  >
                    <v-icon left> mdi-autorenew </v-icon>
                    Limpar
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>

    <v-card class="mt-2">
      <DataTableDeCrud
        :items="itensVO"
        :headers="headers"
        :rotina-id="ID_TELA_DE_ITENS_VO"
        :configurar="false"
        :editar-em-lote="true"
        :info="true"
        :loading="buscando"
        :single-select="false"
        :buscar="false"
        sort-by="codigo"
        show-select
        :options.sync="options"
        :server-items-length="totalDeElementos"
        @create="() => abrirDialogCriarItensVO()"
        @update="(indice) => abrirDialogEditarItemVO(indice)"
        @multi-update="(itens) => abrirDialogEditarEmLoteItensVO(itens)"
        @delete="(indice) => abrirDialogExcluirItensVO(indice)"
        @info="(indice) => abrirDialogInfoItemVO(indice)"
      >
        <template #[`item.ncm`]="{ item }">
          <span @click="abrirEmNovaJanela('TelaDeNCM', { id: item.ncm.id })">
            <a class="deep-orange--text">
              {{ item.ncm ? `${item.ncm.codigo} - ${item.ncm.descricao || 'Sem descrição'} ` : '' }}
            </a>
          </span>
        </template>

        <template #[`item.cest`]="{ item }">
          <span @click="abrirEmNovaJanela('TelaDeCEST', { id: item.cest.id })">
            <a class="deep-orange--text">
              {{
                item.cest ? `${item.cest.codigo} - ${item.cest.descricao || 'Sem descrição'} ` : ''
              }}
            </a>
          </span>
        </template>

        <template #[`item.nesh`]="{ item }">
          <span @click="abrirEmNovaJanela('TelaDeNESH', { id: item.nesh.id })">
            <a class="deep-orange--text">
              {{
                item.nesh ? `${item.nesh.codigo} - ${item.nesh.descricao || 'Sem descrição'} ` : ''
              }}
            </a>
          </span>
        </template>

        <template #[`item.icmsComUf`]="{ item }">
          <span @click="abrirEmNovaJanela('TelaDeICMS', { id: item.icms.id })">
            <a class="deep-orange--text">
              {{ item.icms ? item.icms.uf.sigla + ':' + item.icms.descricao : '' }}
            </a>
          </span>
        </template>

        <template #[`item.pisCofins`]="{ item }">
          <span @click="abrirEmNovaJanela('TelaDePISCOFINS', { id: item.pisCofins.id })">
            <a class="deep-orange--text">
              {{ item.pisCofins ? `${item.pisCofins.descricao || 'Sem descrição'} ` : '' }}
            </a>
          </span>
        </template>

        <template #[`item.natureza`]="{ item }">
          <span @click="abrirEmNovaJanela('TelaDeNatureza', { id: item.natureza.id })">
            <a class="deep-orange--text">
              {{ item.natureza ? item.natureza.codigo : '' }}
            </a>
          </span>
        </template>

        <template #[`item.ipi`]="{ item }">
          <span @click="abrirEmNovaJanela('TelaDeIPI', { id: item.ipi.id })">
            <a class="deep-orange--text">
              {{ item.ipi ? `${item.ipi.descricao || 'Sem descrição'} ` : '' }}
            </a>
          </span>
        </template>
      </DataTableDeCrud>

      <v-dialog v-model="dialogDeleteItemVO" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">Excluir</v-card-title>
          <v-card-text refs="itemVODelete">
            Tem certeza que deseja excluir o item VO <b> {{ itemVODelete.descricao }} </b>?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="dialogDeleteItemVO = false">Cancelar</v-btn>
            <v-btn color="green darken-1" text @click="removerItemVO">Confirmar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <DialogDeMultiEdicaoDeItensVO
        :operacao="operacao"
        :show-dialog.sync="showDialogMultiEdicaoParam"
        :itens-selecionados="itensSelecionadosParam"
        :opcoes="opcoesParam"
        :uf-id="itemUf"
        @confirmado="atualizarItensVO"
      />

      <DialogDeEdicaoDeItensVO
        :show-dialog.sync="showDialogEdicaoParam"
        :item-param="itemVOParam"
        :opcoes="opcoesParam"
        @confirmado="atualizarItensVO"
      />

      <DialogDeInfoDeItemVO
        :show-dialog.sync="showDialogInfoParam"
        :item-param.sync="itemVOParam"
      />

      <SnackbarMessage
        :show-snack.sync="snackbar.showSnackParam"
        :snack-text="snackbar.snackTextParam"
        :snack-type="snackbar.snackTypeParam"
      />
    </v-card>
  </v-container>
</template>

<script>
import ItensVOService from '@/services/itensVO/itensVO'
import NCMService from '@/services/ncm/ncm'
import CESTService from '@/services/cest/cest'
import ICMSService from '@/services/icms/icms'
import NESHService from '@/services/nesh/nesh'
import IPIService from '@/services/ipi/ipi'
import PISCOFINSService from '@/services/pisCofins/pisCofins'
import NaturezaService from '@/services/natureza/natureza'
import SnackbarMessage from '@/components/SnackbarMessage'
import DialogDeMultiEdicaoDeItensVO from '@/components/itensvo/DialogDeMultiEdicaoDeItensVO'
import DialogDeEdicaoDeItensVO from '@/components/itensvo/DialogDeEdicaoDeItensVO'
import DialogDeInfoDeItemVO from '@/components/itensvo/DialogDeInfoDeItemVO'
import DataTableDeCrud from '@/components/DataTableDeCrud'
import SnackBar from '@/models/components/snackbar'
import ItemVO from '@/models/itemvo'
import NCM from '@/models/ncm'
import CEST from '@/models/cest'
import ICMS from '@/models/icms'
import NESH from '@/models/nesh'
import PISCOFINS from '@/models/piscofins'
import IPI from '@/models/ipi'
import Natureza from '@/models/natureza'

import { ID_TELA_DE_ITENS_VO } from '@/common/constants'

export default {
  components: {
    SnackbarMessage,
    DataTableDeCrud,
    DialogDeMultiEdicaoDeItensVO,
    DialogDeEdicaoDeItensVO,
    DialogDeInfoDeItemVO
  },
  data: () => ({
    name: 'TelaDeItensVO',
    headers: [
      { text: 'Código', value: 'codigo', width: '7%', divider: true },
      {
        text: 'Código de Barras',
        value: 'codigoBarra',
        width: '7%',
        divider: true
      },
      { text: 'Descrição', value: 'descricao', width: '13%', divider: true },
      { text: 'NCM', value: 'ncm', width: '7%', divider: true },
      { text: 'CEST', value: 'cest', width: '13%', divider: true },
      { text: 'NESH', value: 'nesh', width: '13%', divider: true },
      { text: 'ICMS', value: 'icmsComUf', width: '9%', divider: true, sortable: false },
      { text: 'PIS COFINS', value: 'pisCofins', width: '13%', divider: true },
      { text: 'Nat', value: 'natureza', width: '5%', divider: true },
      { text: 'IPI', value: 'ipi', width: '11%', divider: true }
    ],
    itensVO: [],
    buscando: false,
    filtro: {},
    panel: 0,
    validForm: false,
    dialog: false,
    operacao: '',
    showDialogEdicaoParam: false,
    showDialogMultiEdicaoParam: false,
    showDialogInfoParam: false,
    itemVOParam: new ItemVO(),
    itensSelecionadosParam: [],
    opcoesParam: {},
    snackbar: new SnackBar(),
    dialogDeleteItemVO: false,
    dialogInfoItemVO: false,
    itemVODelete: new ItemVO(),
    indiceitemVODelete: 0,
    itensSegmento: [],
    itensNCM: [],
    itensUF: [],
    itensOutrosFiltros: [
      'Sem NCM',
      'Sem CEST',
      'Sem ICMS',
      'Sem PIS/COFINS',
      'Sem Código de Barras',
      'ICMS 100% Conferido',
      'Pis Cofins 100% Conferido',
      'Fornecedor 100% Conferido'
    ],
    ID_TELA_DE_ITENS_VO: ID_TELA_DE_ITENS_VO,

    totalDeElementos: 0,
    options: {}
  }),

  computed: {
    itemUf: {
      get() {
        return this.filtro.ufIcmsId ? this.filtro.ufIcmsId : this.itensUF[0]
      },
      set(value) {
        this.filtro.ufIcmsId = value
      }
    }
  },

  watch: {
    options: {
      handler() {
        if (this.filtro.ufIcmsId) this.buscarItensVo()
        else {
          this.buscarUfs().then(() => this.buscarItensVo())
        }
      },
      deep: true
    }
  },

  created() {
    this.initialize()
    if (this.$route.query.descricao) {
      this.filtro.descricao = this.$route.query.descricao
      this.buscarItensVo()
    }
  },

  methods: {
    initialize() {
      try {
        this.loadItens()
      } catch (error) {
        this.snackbar.snackTextParam = 'Não foi possível encontrar itens VO cadastrados.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
    },

    async buscarUfs() {
      try {
        const response = await ICMSService.getUfsVinculadas()

        this.itensUF = response.map((item) => ({
          text: item.nome,
          value: item.id
        }))

        this.itemUf = this.itensUF[0]?.value
      } catch (error) {
        this.snackbar.snackTextParam = `${error.response.status} | ${
          error.response.data.message === undefined ? error.message : error.response.data.message
        }`
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
    },

    async buscarItensVo() {
      this.buscando = true
      this.itensVO = []

      const pagination = {
        page: this.options.page - 1,
        size: this.options.itemsPerPage,
        sort: this.options.sortBy.map(
          (sort, indice) => `${sort},${this.options.sortDesc[indice] ? 'DESC' : 'ASC'}`
        )[0]
      }

      try {
        this.itensSelecionadosParam = []

        const queryParams = {
          descricao: this.filtro.descricao || undefined,
          codigoBarra: this.filtro.codigoBarra || undefined,
          codigoNcm: this.filtro.codigoNcm || undefined,
          codigoNesh: this.filtro.codigoNesh || undefined,
          ufIcmsId: this.filtro.ufIcmsId,
          codigoVo: this.filtro.codigoVo || undefined,
          semNcm: this.filtro.outros === 'Sem NCM' || undefined,
          semCest: this.filtro.outros === 'Sem CEST' || undefined,
          semIcms: this.filtro.outros === 'Sem ICMS' || undefined,
          semPisCofins: this.filtro.outros === 'Sem PIS/COFINS' || undefined,
          semCodigoBarras: this.filtro.outros === 'Sem Código de Barras' || undefined,
          conferidoIcms: this.filtro.outros === 'ICMS 100% Conferido' || undefined,
          conferidoPisCofins: this.filtro.outros === 'Pis Cofins 100% Conferido' || undefined,
          conferidoFornecedor: this.filtro.outros === 'Fornecedor 100% Conferido' || undefined
        }

        const response = await ItensVOService.getAll({ ...queryParams, ...pagination })

        const reponseItensICMS = await ICMSService.getAll({ ufId: this.filtro.ufIcmsId })
        this.itensICMS = this.normalizeItens(reponseItensICMS)

        this.itensVO = response.content
        this.totalDeElementos = response.totalElements
      } catch (error) {
        this.snackbar.snackTextParam = `${error.response.status} | ${
          error.response.data.message === undefined ? error.message : error.response.data.message
        }`
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      } finally {
        this.buscando = false
      }
    },

    async loadItens() {
      const [
        itensNCM,
        itensCEST,
        itensICMS,
        itensNESH,
        itensIPI,
        itensPISCOFINS,
        itensNatureza
      ] = await Promise.all([
        NCMService.getAll(),
        CESTService.getAll(),
        ICMSService.getAll(),
        NESHService.getAll(),
        IPIService.getAll(),
        PISCOFINSService.getAll(),
        NaturezaService.buscarTipoMovimentoSaida()
      ])

      this.itensNCM = this.normalizeItens(itensNCM)
      this.itensCEST = this.normalizeItens(itensCEST)
      this.itensICMS = this.normalizeItens(itensICMS)
      this.itensNESH = this.normalizeItens(itensNESH)
      this.itensIPI = this.normalizeItens(itensIPI)
      this.itensPISCOFINS = this.normalizeItens(itensPISCOFINS)
      this.itensNatureza = this.normalizeItens(itensNatureza)
    },

    normalizeItens(res) {
      return res.map((item) => ({
        text: (item.codigo ? item.codigo + ' - ' : '') + item.descricao,
        value: item.id
      }))
    },

    atualizarItemVO(itemVO) {
      if (!itemVO) return

      const indice = this.itensVO.findIndex((itemVOExistente) => itemVOExistente.id === itemVO.id)

      if (indice === -1) {
        this.itensVO.push(itemVO)
        this.snackbar.snackTextParam = 'Item VO criado com sucesso.'
      } else {
        this.itensVO.splice(indice, 1, itemVO)
        this.snackbar.snackTextParam = 'Item VO atualizado com sucesso.'
      }

      this.snackbar.snackTypeParam = 'sucess'
      this.snackbar.showSnackParam = true
    },

    atualizarItensVO(itensNovos) {
      if (this.operacao === 'adicionar') {
        this.snackbar.snackTextParam = 'Item VO criado com sucesso.'
        this.itensVO.push(itensNovos)
      } else {
        this.snackbar.snackTextParam = 'Item VO atualizado com sucesso.'
        const itensNovosArray = itensNovos instanceof Array ? itensNovos : [itensNovos]

        this.itensVO.forEach((itemVO) => {
          itensNovosArray.map((item) => {
            if (itemVO.id === item.id) {
              Object.assign(this.itensVO[this.itensVO.indexOf(itemVO)], item)
            }
          })
        })
      }

      this.snackbar.snackTypeParam = 'sucess'
      this.snackbar.showSnackParam = true
    },

    abrirDialogExcluirItensVO(indice) {
      this.itemVODelete = this.itensVO[indice]
      if (!this.itemVODelete.id) return

      this.indiceitemVODelete = indice
      this.dialogDeleteItemVO = true
    },

    abrirDialogInfoItemVO(indice) {
      this.itemVOParam = this.itensVO[indice]
      if (!this.itemVOParam.id) return

      this.showDialogInfoParam = true
    },

    async removerItemVO() {
      try {
        await ItensVOService.deleteById(this.itemVODelete.id)
        this.snackbar.snackTextParam = 'Item VO removido com sucesso.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true
        this.itensVO.splice(this.indiceitemVODelete, 1)
      } catch (error) {
        this.snackbar.snackTextParam = `${error.response.status} | ${
          error.response.data.message === undefined ? error.message : error.response.data.message
        }`
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
      this.dialogDeleteItemVO = false
    },

    abrirDialogCriarItensVO() {
      this.operacao = 'adicionar'
      this.opcoesParam = {
        ncm: this.itensNCM,
        cest: this.itensCEST,
        icms: this.itensICMS,
        nesh: this.itensNESH,
        ipi: this.itensIPI,
        pisCofins: this.itensPISCOFINS,
        natureza: this.itensNatureza,
        uf: this.itensUF
      }
      this.itemVOParam = new ItemVO()
      this.showDialogMultiEdicaoParam = true
    },

    abrirDialogEditarItemVO(indice) {
      this.operacao = 'editar'

      this.itensParam = {
        ncm: this.itensNCM,
        cest: this.itensCEST,
        icms: this.itensICMS,
        nesh: this.itensNESH,
        ipi: this.itensIPI,
        pisCofins: this.itensPISCOFINS,
        natureza: this.itensNatureza,
        uf: this.itensUF
      }

      this.itemVOParam = { ...this.itensVO[indice] }

      if (!this.itemVOParam.ncm) this.itemVOParam.ncm = new NCM()
      if (!this.itemVOParam.cest) this.itemVOParam.cest = new CEST()
      if (!this.itemVOParam.icms) this.itemVOParam.icms = new ICMS()
      if (!this.itemVOParam.nesh) this.itemVOParam.nesh = new NESH()
      if (!this.itemVOParam.pisCofins) this.itemVOParam.pisCofins = new PISCOFINS()
      if (!this.itemVOParam.ipi) this.itemVOParam.ipi = new IPI()
      if (!this.itemVOParam.natureza) this.itemVOParam.natureza = new Natureza()

      this.showDialogEdicaoParam = true
    },

    abrirDialogEditarEmLoteItensVO(itens) {
      this.operacao = 'editar'
      this.opcoesParam = {
        ncm: this.itensNCM,
        cest: this.itensCEST,
        icms: this.itensICMS,
        nesh: this.itensNESH,
        ipi: this.itensIPI,
        pisCofins: this.itensPISCOFINS,
        natureza: this.itensNatureza,
        uf: this.itensUF
      }
      this.itensSelecionadosParam = itens
      this.showDialogMultiEdicaoParam = true
    },

    limparSelecaoDeFiltros() {
      this.filtro = {}
    },

    abrirEmNovaJanela(routeName, parameter) {
      let routeData = this.$router.resolve({
        name: routeName,
        query: parameter,
        params: parameter
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style scoped>
::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
  font-size: calc(0.3rem + 1vmin);
}
</style>
